import miniaSerpico from "../assets/images/Miniatures/minia-serpico.png";
import miniaAzura from "../assets/images/Miniatures/minia-azura.png";
import miniaPSX from "../assets/images/Miniatures/minia-psx.png";
import miniaWizgems from "../assets/images/Miniatures/minia-wizgems.png";
import miniaGamebuino from "../assets/images/Miniatures/minia-gamebuino.png";
import miniaMonoDungeon from "../assets/images/Miniatures/Minia-monogame-dungeon.png";
//import miniaMonoUI from "../assets/images/Miniatures/Minia-monogame-ui.png";
import miniaOGL from "../assets/images/Miniatures/Minia-OpenGL.png";

const codesData = [
    { slug: "serpico", image: miniaSerpico, texte: "Serpico - PSX Framework", sousTexte: "PSX 2D/3D custom C engine" },
    { slug: "azura", image: miniaAzura, texte: "Azura - Water Simulation", sousTexte: "Unity Plugin for Water sim"},
    { slug: "psx", image: miniaPSX, texte: "Low level 3D Engine on PSX", sousTexte: "PSX Dev in C using Psy-Q lib" },
    { slug: "wizgems", image: miniaWizgems, texte: "2D Catching game on PSX", sousTexte: "2D game in C on PSX (Psy-Q)" },
    { slug: "gamebuino", image: miniaGamebuino, texte: "Dungeon Crawler on Gamebuino", sousTexte: "C++ First Person Dungeon (Arduino)" },
    { slug: "mono-dungeon", image: miniaMonoDungeon, texte: "Monogame Dungeon Crawler", sousTexte: "C# Dungeon Crawler" },
    //{ slug: "mono-ui", image: miniaMonoUI, texte: "Monogame UI Implementation", sousTexte: "C# UI Module" },
    { slug: "ogl", image: miniaOGL, texte: "C++ OpenGL 3D Engine", sousTexte: "Open GL model viewer" }
];

export default codesData;